import { z } from 'zod';

/////////////////////////////////////////
// CASE SCHEMA
/////////////////////////////////////////

export const CaseSchema = z.object({
  caseId: z.number().int(),
  cityId: z.number().int(),
  caseType: z.string(),
  classificationId: z.number().int(),
  departmentId: z.number().int(),
  contactId: z.number().int(),
  contact2Id: z.number().int(),
  howNotify: z.string(),
  description: z.string(),
  location: z.string(),
  locationCoord: z.string(),
  locationCoordGPS: z.string().nullable(),
  dateEntered: z.coerce.date(),
  howEntered: z.string(),
  enteredById: z.number().int(),
  status: z.string(),
  assignedToId: z.number().int(),
  dateClosed: z.coerce.date(),
  closedById: z.number().int(),
  reasonClosed: z.string(),
  dateExpectClose: z.coerce.date(),
  priority: z.string(),
  account: z.string(),
  workDone: z.string(),
  zone: z.string(),
  incidentDate: z.string(),
  incidentTime: z.string(),
  surveyId: z.number().int(),
  cecaseId: z.string(),
  linkedId: z.string(),
  park: z.string(),
  facility: z.string(),
  extra1: z.string(),
  extra2: z.string(),
  extra3: z.string(),
  extra4: z.string(),
  extra5: z.string(),
  extra6: z.string(),
  flag1: z.number().int(),
  flag2: z.number().int(),
  flag3: z.number().int(),
  phoneWhenRequestClosed: z.number().int(),
  lang: z.string(),
  caseUpdated: z.number().int(),
  mobileLocationManual: z.number().int(),
  hasAttachment: z.number().int(),
  classification: z.string(),
  crew: z.string(),
  media: z.string(),
  displayId: z.string(),
  enteredByIPAddress: z.string(),
  primaryImageId: z.number().int(),
  mobileType: z.number().int(),
  mobileToken: z.string(),
  dateLastUpdated: z.coerce.date(),
  notPublic: z.number().int(),
  cpSRId: z.string(),
  cpAddress: z.string(),
  cpWOType: z.string(),
  cpWOInfo: z.string(),
  externalId: z.string().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type Case = z.infer<typeof CaseSchema>

export default CaseSchema;
